import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    swipeDiv: {
      display: 'grid',
      height: '100%'
    },
}))